<section class="insurance-wrap">
  <div class="wrap-lg">
    <div class="insurance-inner">
      <div class="nav-sec">
        <div class="back-nav">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name" (click)="back()" >Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Insurance Addition</div>
          <div class="page-info">Would you like to include Insurance with your loan?</div>
        </div>
      </div>
      <div class="box-wrap">
        <div class="insurance-list" >
          <div class="insurance-item" *ngFor='let insurance of util.getCache("insuranceList"); let i = index' [ngClass]="{'selected': selectedCard === i} "(click)="selectCard(i)">
            <div class="recommend-tag" *ngIf="insurance.id == 1">Recommend</div>
            <div class="insurance-title">
              <div class="option-dot" ></div>
        
              {{insurance.id == 1 ? 'Critical Illness + Personal Accident' : 'Critical Illness + Personal Accident with EMI Shield'}}
              <span class="lite">{{insurance.id == 1 ? '(Base Cover)' : ''}}</span>
            </div>
            <div class="insurance-amount">
              
              <div class="amount-item">
                <div class="label">Premium Amount</div>
                <div class="value">{{insurance.premium | currency: 'INR': 'symbol':'1.2-2'}}</div>
              </div>
              <div style="position: relative;">
                <div class="gradient-line"></div>
              </div>
              <div class="amount-item">
                <div class="label">Loan Amount</div>
                <div class="value">{{util.loanDetails.amount + insurance.premium | currency: 'INR': 'symbol':'1.2-2'}}</div>
              </div>
            </div>
            <!-- With Moratorium -->
            <!-- <div class="insurance-info">
              <div class="info-title">Revised EMI with Moratorium</div>
              <div class="info-item">
                <div class="info-left">Pay <span class="value">₹{{payMonths}}</span></div>
                <div class="info-right">for first <span class="value">3 months</span></div>
              </div>
              <div class="info-item">
                <div class="info-left">then <span class="value">₹{{thenMonths}}</span></div>
                <div class="info-right">for next <span class="value">9 months</span></div>
              </div>
            </div> -->
            <!-- Without Moratorium -->
            <div class="insurance-info">
              <div class="info-single">Revised EMI <span class="value">₹{{insurance.emiAmount}}</span></div>
            </div>
          </div>
        </div>
        
        <div class="benefits">Read more about the benefits ?  <span class="action" (click)="showBenefits()">Click here</span></div>
        <form [formGroup]="formGroup">
        <div class="nominee-details">
          <div class="nominee-title">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
              <g id="vuesax/bulk/profile">
              <g id="profile">
              <path id="Vector" d="M12.0083 2.00439C9.38639 2.00439 7.25488 4.12566 7.25488 6.73491C7.25488 9.29437 9.26631 11.3658 11.8882 11.4555C11.9682 11.4455 12.0483 11.4455 12.1083 11.4555C12.1283 11.4555 12.1383 11.4555 12.1584 11.4555C12.1684 11.4555 12.1684 11.4555 12.1784 11.4555C14.7402 11.3658 16.7516 9.29437 16.7616 6.73491C16.7616 4.12566 14.6301 2.00439 12.0083 2.00439Z" fill="#10D7EE"/>
              <path id="Vector_2" d="M17.0925 14.1046C14.3005 12.2522 9.74726 12.2522 6.93526 14.1046C5.66436 14.9511 4.96387 16.0964 4.96387 17.3214C4.96387 18.5463 5.66436 19.6816 6.92526 20.5182C8.32625 21.4543 10.1676 21.9224 12.0089 21.9224C13.8502 21.9224 15.6915 21.4543 17.0925 20.5182C18.3534 19.6717 19.0539 18.5364 19.0539 17.3014C19.0439 16.0765 18.3534 14.9412 17.0925 14.1046Z" fill="#17151C"/>
              </g>
              </g>
            </svg>Nominee details
          </div>
          <div class="nominee-form">
            <div class="form-item">
              <label class="form-label">Nominee’s name as per PAN</label>
              <input class="cus-input" type="text" placeholder="Enter name" formControlName ='name'/>
            </div>
            <div class="form-item">
              <label class="form-label">Nominee’s relationship with insured</label>
              <div class="cus-dropdown" (click)="openDrop('nominee_drop')">
                <input class="cus-input" type="text"  placeholder="Select relationship" formControlName ='relationship' readonly/>
                <div id="nominee_drop" class="drop-content" >
                  <div class="drop-item" *ngFor="let nominee of data.getDataFromContantAll('insurance_nominee')" (click)="getRelationship(nominee.id,nominee.relation)">{{nominee.relation}}</div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
        <div class="cus-check nominee-agree">
          <input class="input-check" type="checkbox" id="nominee_agree" [(ngModel)]="isChecked"/>
          <label for="nominee_agree">I hereby agree to the product <span class="action" (click)="showTc()">term & conditions</span> and the declarations mentioned below for the purchase of this policy.</label>
        </div>
        <div class="nominee-faq">
          <div class="faq-item">
            <div class="faq-head selected" (click)="showFaq('nominee_faq_1', $event)">Acknowledgement that insurance is not mandatory.</div>
            <div id="nominee_faq_1" class="faq-content open">I acknowledge that availing any insurance is not a condition for availing the Loan. If I have indicated my choice to opt for insurance, the Lender is requested to facilitate the same and instructed to include the premium amount to the Loan amount and to deduct the premium amount from the loan disbursement amount towards payment of the premium amount to the insurance provider.</div>
          </div>
          <div class="faq-item">
            <div class="faq-head" (click)="showFaq('nominee_faq_2', $event)">Instruction to the insurance company to pay the Lender directly.</div>
            <div id="nominee_faq_2" class="faq-content">I hereby authorize Care Health Insurance Limited to pay directly to Northern Arc Capital Ltd. towards my outstanding dues against the loan from Northern Arc Capital Ltd. out of the claim proceeds or premium refunds under Policy issued by Care Health Insurance Limited in my name.</div>
          </div>
          <div class="faq-item">
            <div class="faq-head" (click)="showFaq('nominee_faq_3', $event)">Good Health Declaration</div>
            <div id="nominee_faq_3" class="faq-content">I hereby declare that I am in good health and entirely free from any mental or physical impairments or deformities, disease/condition. Neither have I been hospitalized for treatment of an illness or injury in the past nor consulted any physician or conducted investigation for reasons other than common cough, cold or flu. I am not a habitual consumer of alcohol, tobacco, gutka or any recreational drugs.</div>
          </div>
        </div>
        <div class="page-action">
          <div class="action-info"><strong>NOTE:</strong>The Policy Document will be mailed to you.</div>
          <button class="btn-secondary" (click)="saveInsuranceDetails(true)">Skip</button>
          <button class="btn-primary" [class.disable]="!(formGroup.valid && isChecked)" (click)="saveInsuranceDetails(false)">Continue</button>
        </div>
      </div>
    </div>
  </div>
</section>

<p-dialog [(visible)]="showInsuranceBenefits" [modal]="true" styleClass="cus-dialog-md cus-dialog insurance-dialog" [draggable]="false" [resizable]="false">
  <iframe width="100%" height="400px" [src]="iframeSrc" frameborder="0" allowfullscreen style="overflow: hidden;">
  </iframe>
</p-dialog>

<p-dialog [(visible)]="showTC" [modal]="true" styleClass="cus-dialog-md cus-dialog insurance-dialog" [draggable]="false" [resizable]="false">
  <iframe width="100%" height="400px" [src]="iframeSrc2" frameborder="0" allowfullscreen style="overflow: hidden;">
  </iframe>
</p-dialog>
